import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient'; // On ajoute Supabase
import Icon from '../AppIcon';
import SearchBar from './SearchBar';
// On retire UserAccountIndicator car on met la logique directement ici pour afficher la vraie photo
// import UserAccountIndicator from './UserAccountIndicator'; 

import logoAfaqi from '../../assets/logo.jpg';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // --- NOUVEAU : États pour gérer le vrai profil ---
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  // ------------------------------------------------

  const location = useLocation();

  const navigationItems = [
    {
      label: 'Accueil',
      path: '/homepage',
      icon: 'Home',
      description: 'Page d\'accueil et vue d\'ensemble'
    },
    {
      label: 'Orientation Lycée',
      path: '/lycee-orientation',
      icon: 'GraduationCap',
      description: 'Exploration des filières et orientation baccalauréat'
    },
    {
      label: 'Écoles & Universités',
      path: '/post-bac-database',
      icon: 'School',
      description: 'Base de données des établissements post-bac'
    },
    {
      label: 'Calendrier',
      path: '/admission-calendar',
      icon: 'Calendar',
      description: 'Calendrier des admissions et échéances'
    },
    {
      label: 'Mon Profil',
      path: '/student-profile',
      icon: 'User',
      description: 'Profil étudiant et recommandations personnalisées'
    }
  ];

  // --- NOUVEAU : Logique de récupération Supabase ---
  useEffect(() => {
    // 1. Fonction pour charger les détails (photo, nom)
    const fetchProfile = async (userId) => {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('full_name, avatar_url')
          .eq('id', userId)
          .single();

        if (data && !error) {
          setUserProfile(data);
        }
      } catch (err) {
        console.error("Erreur header:", err);
      }
    };

    // 2. Vérifier qui est connecté
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
      if (session?.user) {
        fetchProfile(session.user.id);
      }
    };
    checkUser();

    // 3. Écouter les changements de connexion
    const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) {
        fetchProfile(session.user.id);
      } else {
        setUserProfile(null);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  // Fermer le menu si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setUserProfile(null);
    setIsProfileDropdownOpen(false);
    navigate('/');
  };
  // ------------------------------------------------

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Helper pour les initiales si pas de photo
  const getInitials = () => {
    if (userProfile?.full_name) {
      return userProfile.full_name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
    return user?.email?.[0].toUpperCase() || 'U';
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-card border-b border-border shadow-soft">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo (Ton logo original) */}
          <Link 
            to="/homepage" 
            className="flex items-center transition-smooth hover:opacity-80"
          >
            <img src={logoAfaqi} alt="Afaqi" className="h-10 w-auto object-contain" />
          </Link>

          {/* Desktop Navigation (Ta navigation originale) */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-smooth hover:bg-muted ${
                  isActivePath(item?.path)
                    ? 'text-primary bg-primary/10' :'text-muted-foreground hover:text-foreground'
                }`}
                title={item?.description}
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          {/* Desktop Right Section (MODIFIÉ : Vrai Profil Supabase) */}
          <div className="hidden lg:flex items-center space-x-4">
            <SearchBar />
            
            {/* Ici on remplace UserAccountIndicator par le vrai affichage */}
            {user ? (
                <div className="relative" ref={dropdownRef}>
                    <button 
                        onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                        className="flex items-center space-x-3 p-1 pr-3 rounded-full border border-border hover:bg-muted transition-colors"
                    >
                        {/* Avatar */}
                        <div className="w-9 h-9 rounded-full overflow-hidden bg-primary/10 flex items-center justify-center border border-primary/20">
                            {userProfile?.avatar_url ? (
                                <img src={userProfile.avatar_url} alt="Profil" className="w-full h-full object-cover" />
                            ) : (
                                <span className="text-xs font-bold text-primary">{getInitials()}</span>
                            )}
                        </div>
                        {/* Nom */}
                        <div className="flex flex-col items-start">
                            <span className="text-sm font-medium text-foreground max-w-[120px] truncate">
                                {userProfile?.full_name || 'Utilisateur'}
                            </span>
                        </div>
                        <Icon name="ChevronDown" size={14} className="text-muted-foreground" />
                    </button>

                    {/* Dropdown Menu */}
                    {isProfileDropdownOpen && (
                        <div className="absolute right-0 top-full mt-2 w-56 bg-card border border-border rounded-xl shadow-lg py-2 z-50 animate-fade-in">
                             <div className="px-4 py-2 border-b border-border mb-2">
                                <p className="text-sm font-semibold truncate">{userProfile?.full_name}</p>
                                <p className="text-xs text-muted-foreground truncate">{user.email}</p>
                             </div>
                             <Link 
                                to="/student-profile" 
                                className="flex items-center px-4 py-2 text-sm text-foreground hover:bg-muted"
                                onClick={() => setIsProfileDropdownOpen(false)}
                             >
                                <Icon name="User" size={16} className="mr-2" /> Mon Profil
                             </Link>
                             <button 
                                onClick={handleLogout}
                                className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                             >
                                <Icon name="LogOut" size={16} className="mr-2" /> Déconnexion
                             </button>
                        </div>
                    )}
                </div>
            ) : (
                <Link to="/login" className="px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary/90">
                    Connexion
                </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Menu de navigation"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </div>
      
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-50 bg-background">
          <div className="flex flex-col h-full">
            {/* Mobile Header */}
            <div className="flex items-center justify-between p-4 border-b border-border">
              <Link 
                to="/homepage" 
                className="flex items-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <img src={logoAfaqi} alt="Afaqi" className="h-8 w-auto object-contain" />
              </Link>
              <button
                onClick={toggleMobileMenu}
                className="p-2 rounded-lg hover:bg-muted transition-smooth"
              >
                <Icon name="X" size={24} />
              </button>
            </div>

            {/* Mobile Search */}
            <div className="p-4 border-b border-border">
              <SearchBar />
            </div>

            {/* Mobile Navigation */}
            <nav className="flex-1 p-4 space-y-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 p-4 rounded-lg transition-smooth ${
                    isActivePath(item?.path)
                      ? 'text-primary bg-primary/10' :'text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <div className="flex-1">
                    <div className="font-medium">{item?.label}</div>
                    <div className="text-sm text-muted-foreground mt-1">
                      {item?.description}
                    </div>
                  </div>
                </Link>
              ))}
            </nav>

            {/* Mobile User Section (Mise à jour avec la vraie photo aussi) */}
            <div className="p-4 border-t border-border">
                {user ? (
                    <div className="space-y-3">
                        <div className="flex items-center space-x-3 bg-muted/50 p-3 rounded-lg">
                            <div className="w-10 h-10 rounded-full overflow-hidden bg-background border border-border">
                                {userProfile?.avatar_url ? (
                                    <img src={userProfile.avatar_url} alt="Profil" className="w-full h-full object-cover" />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-primary font-bold">{getInitials()}</div>
                                )}
                            </div>
                            <div>
                                <p className="font-semibold text-sm">{userProfile?.full_name || 'Utilisateur'}</p>
                                <p className="text-xs text-muted-foreground">{user.email}</p>
                            </div>
                        </div>
                        <Link 
                            to="/student-profile" 
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="flex items-center justify-center w-full px-4 py-2 bg-primary/10 text-primary rounded-lg font-medium"
                        >
                            Mon Profil
                        </Link>
                        <button 
                            onClick={() => { handleLogout(); setIsMobileMenuOpen(false); }}
                            className="flex items-center justify-center w-full px-4 py-2 bg-red-50 text-red-600 rounded-lg font-medium"
                        >
                            Se déconnecter
                        </button>
                    </div>
                ) : (
                    <Link to="/login" className="flex items-center justify-center w-full px-4 py-3 bg-primary text-white rounded-lg font-medium">
                        Se connecter
                    </Link>
                )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;